var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50245 0.805287L9.05863 0.805287C9.25221 0.805287 9.43759 0.882206 9.57441 1.01903C10.2478 1.69245 13.5345 4.97947 14.5399 5.98455C14.8246 6.26924 14.8246 6.73081 14.5399 7.0155L9.57442 11.981C9.43759 12.1178 9.25221 12.1948 9.05863 12.1945C8.7503 12.1945 8.0794 12.1944 7.50245 12.1948C7.20768 12.1948 6.94159 12.017 6.82872 11.7446C6.71617 11.4722 6.77828 11.1585 6.98699 10.9501L11.3674 6.5697C11.4058 6.53124 11.4058 6.46881 11.3674 6.43035L6.98698 2.04998C6.77828 1.84158 6.71617 1.52788 6.82872 1.25549C6.94159 0.983093 7.20767 0.805287 7.50245 0.805287ZM1.61067 0.805287L3.16685 0.805287C3.36011 0.805287 3.5458 0.882207 3.68231 1.01903L8.64783 5.98455C8.93252 6.26924 8.93252 6.73081 8.64783 7.0155L3.68231 11.981C3.5458 12.1178 3.36011 12.1948 3.16685 12.1945C2.8582 12.1945 2.1873 12.1944 1.61067 12.1948C1.31557 12.1948 1.0498 12.017 0.936934 11.7446C0.824067 11.4722 0.88649 11.1585 1.09488 10.9501L5.47526 6.5697C5.51372 6.53124 5.51372 6.46881 5.47526 6.43035L1.09488 2.04998C0.88649 1.84158 0.824066 1.52788 0.936933 1.25549C1.0498 0.983093 1.31557 0.805287 1.61067 0.805287Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOpen);
export default __webpack_public_path__ + "static/media/group-open.6bce040c55adbaa04490fe8dbfa41fc3.svg";
export { ForwardRef as ReactComponent };